import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import { getLocale } from "./utils/helpers";
i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    debug: ENV === "development",
    lng: getLocale(),
    backend: {
      loadPath:
        LOCAL_ENV === "true"
          ? "/i18n/locales/{{lng}}.json"
          : "/assets/account/profile/locales/{{lng}}.json",
    },
    nsSeparator: "::",
    keySeparator: false,
    lowerCaseLng: true,
    load: "currentOnly",
    fallbackLng: "en-us",
    react: {
      wait: false,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default",
    },
  });

export default i18n;
